<!-- eslint-disable max-len -->
<template lang="pug">
.container
  Breadcrumbs
  .alert.alert-dismissible.alert-success(
    role='alert',
    v-show='getSolicitation.cdSolicitacao !== ""'
  )
    .alert__icon
      Icon(name='shield')
    .alert__content Parabéns! Sua solicitação foi enviada com sucesso! Verifique seu e-mail.
    button.btn-close.align-items-center(
      type='button',
      data-bs-dismiss='alert',
      aria-label='Fechar'
    )
      Icon(name='xmark')

  h1.h-large Guia de instalação do Certificado Digital em nuvem

  h4 Veja abaixo onde você pode instalar e como utilizar o Certificado Digital Bird ID

  .row.justify-content-center.gap-4
    .col-md.card.card-info
      h4 Através do Portal Bird ID
      .img-box(
        @mouseover='startAnimation("page")',
        @mouseleave='stopAnimation("page")'
      )
        img#pageImg(
          src='@/assets/images/browser.svg',
          alt='Ilustração de uma página da internet'
        )
        img(
          v-show='pageImg',
          src='../../assets/images/browser.gif',
          alt='Ilustração animada de uma página da internet',
          style='max-height: 119px !important'
        )
      p Acesse o #[strong Portal Bird ID, insira seu código de usuário e senha de emissão] e pronto! Seu Certificado Digital estará pronto para ser utilizado tanto no #[strong Bird ID App] quanto no #[strong Bird ID Desktop].
      a.btn.btn-outline-primary(
        type='button',
        href='/ManuaEmissaoBirdId.pdf',
        target='_blank'
      )
        Icon.me-2(name='up-right-from-square')
        span Abrir guia de instalação
      a.btn.btn-primary(
        href='https://painel.birdid.com.br/#/enrollment-1/portal',
        target='_blank',
        type='button'
      )
        Icon.me-2(name='up-right-from-square')
        span Acesse o Portal Bird Id

    .col-md.card.card-info
      h4 Através do Bird ID App
      .img-box
        img(
          width='155',
          height='126',
          src='@/assets/images/Bird2.svg',
          alt='Logo tipo do aplicativo BirdId'
        )
      p Instale o Bird Id App em seu celular e faça a instalação do Certificado Digital #[strong dentro do aplicativo]. Tenha em mãos #[strong seu código de usuário, senha de emissão e os dados de acesso ao Portal Bird ID].
      .d-flex.justify-content-between(v-if='isMobile')
        .col-md-6
          a(
            href='https://play.google.com/store/apps/details?id=br.com.vaultid.apps.authenticator&hl=pt_BR',
            target='_blank',
            type='button'
          )
            img(
              src='@/assets/images/btn_google.svg',
              alt='Logo da loja da Play Store'
            )
        .col-md-6
          a(
            href='https://apps.apple.com/us/app/birdid/id1450002184',
            target='_blank',
            type='button'
          )
            img(
              src='@/assets/images/btn_apple.svg',
              alt='Logo da loja da Apple Store'
            )
      a.btn.btn-outline-primary(
        type='button',
        href='/ManuaEmissaoBirdId.pdf',
        target='_blank'
      )
        Icon.me-2(name='up-right-from-square')
        span Abrir guia de instalação
      button.btn.btn-outline-primary(style='opacity: 0') Empty

    .col-md.card.card-info
      h4 Através do Bird ID Desktop
      .img-box(
        @mouseover='startAnimation("desktop")',
        @mouseleave='stopAnimation("desktop")'
      )
        img#desktopImg(
          src='@/assets/images/desktop.svg',
          alt='Ilustração de um computador'
        )
        img(
          v-show='desktopImg',
          src='@/assets/images/desktop-animado.gif',
          alt='Ilustração animada de um computador'
        )
      p Caso queira assinar documentos, utilize o #[strong Bird ID Desktop] em seu computador.
      a.btn.btn-outline-primary(
        type='button',
        href='/ManuaEmissaoBirdId.pdf',
        target='_blank'
      )
        Icon.me-2(name='up-right-from-square')
        span Abrir guia de instalação
      a#button-download.btn.btn-primary(
        href='https://www.soluti.com.br/certificado-bird-id#assistentebirdred',
        target='_blank',
        type='button',
        @click='showModal'
      )
        Icon.me-2(name='download')
        span Baixar Bird ID desktop

  Contact.contact

Modal#modalSentDesktop(ref='myModal')
  template(v-slot:modal-header='')
    button.btn-close(
      type='button',
      data-bs-dismiss='modal',
      aria-label='Close'
    )
  template(v-slot:modal-body='')
    h2 A instalação do Bird ID Desktop deve ser feita através de um #[strong computador ou notebook].
    img(src='@/assets/images/sent-desktop.svg', alt='menina sorrindo')
  template(v-slot:modal-footer='')
    button.btn.btn-primary(
      type='button',
      data-bs-dismiss='modal',
      aria-label='Close'
    )
      Icon(name='thumbs-up')
      span.ms-2 Ok. Entendi!

    button.btn.btn-outline-info(type='button', @click='sendLink')
      Icon(name='share-nodes')
      span.ms-2 Compartilhar
</template>

<script lang="ts">
  import { defineComponent } from 'vue'
  import Icon from '@/components/Atoms/Icon.vue'
  import Contact from '@/components/Molecules/Contact.vue'
  import Breadcrumbs from '@/components/Molecules/Breadcrumbs.vue'
  import Modal from '@/components/Molecules/Modal.vue'
  import mobileAndTabletCheck from '@/utils/browserDeviceCheck'
  import { mapActions, mapState } from 'pinia'
  import { useSolicitation } from '@/store/Pinia/useSolicitation.store'
  import { useToastGlobal } from '@/store/Pinia/useToastGlobal.store'

  export default defineComponent({
    name: 'InstallationGuideBirdIdView',
    components: {
      Icon,
      Breadcrumbs,
      Contact,
      Modal,
    },
    data: () => ({
      form: {
        showAlert: false,
      },
      isMobile: false,
      pageImg: false,
      desktopImg: false,
      linkTo: '',
    }),
    computed: {
      ...mapState(useSolicitation, ['getSolicitation']),
    },
    methods: {
      ...mapActions(useToastGlobal, ['toggleToastGlobal']),
      actionButton(link: string) {
        if (!this.isMobile) {
          window.open(link, '_blank')
        }
      },
      startAnimation(imgName: string) {
        if (imgName === 'page') {
          this.pageImg = true
          return
        }
        this.desktopImg = true
      },
      stopAnimation(imgName: string) {
        if (imgName === 'page') {
          this.pageImg = false
          return
        }
        this.desktopImg = false
      },
      showModal() {
        if (!this.isMobile) {
          window.open('https://birdid.com.br/suporte.html', '_blank')
        }
      },
      async sendLink(link: string) {
        try {
          const shareData = {
            url: link,
          }
          await navigator.share(shareData)
        } catch (_error) {
          this.toggleToastGlobal({
            isShow: true,
            type: 'info',
            message: 'O link não foi enviado,',
          })
        }
      },
    },
    mounted() {
      this.isMobile = mobileAndTabletCheck()
      if (this.isMobile) {
        const modal = document.getElementById('button-download') as HTMLElement
        modal.setAttribute('data-bs-toggle', 'modal')
        modal.setAttribute('data-bs-target', '#modalSentDesktop')
      }
    },
  })
</script>

<style lang="stylus" scoped>

  .card
    &:hover
      box-shadow: 0 .5rem 1rem rgba(0,0,0,.15)!important

  #pageImg
    height: 119px
    position absolute
    &:hover
      opacity: 0

  #desktopImg
    height: 170px
    position absolute
    &:hover
      opacity: 0
  .img-box
    display: flex;
    align-items: center;
    justify-content: center;
    height: 200px
    width: 100%

    img
      height: 200px

  .h-medium
    font-weight: 400

  .h-large
    font-size: 2rem
  .card-info
    padding: 1rem
    justify-content: space-between
    gap: 1rem

    h4
      text-align: center
      font-size: 1.3rem
    p
      min-height 10rem
  .container
    display: flex
    flex-direction: column
    flex-wrap: wrap
    gap: 2rem
    text-align: left
    padding: 2rem

  @media screen and (max-width: 550px)
    .container
      p
        min-height: 5rem
  @media screen and (min-width: 768px)
    .contact
      margin-bottom: 4rem !important
</style>
